export const DEFAULT_METADATA_STATE = {
  metadataList: [],
  selectedMetadata: null,
  loading: false,
  error: null,
  success: false,
};
